import { useEffect, useState } from 'react';
import { TeamRegistrationService } from './TeamRegistrationService';
import type { RegistrationWindowFields } from './TeamRegistration.types';

/**
 * A clock for the Jahresmeldungen table: one timer for the whole list, not one
 * per row, re-scheduling itself at the rate the rows currently need.
 *
 * The rate is asked for again after every tick, so a list that sits on screen
 * speeds up on its own as a deadline comes within the hour and the countdowns
 * start showing seconds.
 */
export function useCountdownClock(
  rows: ReadonlyArray<RegistrationWindowFields>,
): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    const tick = () => {
      const current = new Date();
      setNow(current);
      timer = setTimeout(
        tick,
        TeamRegistrationService.countdownTickMs(rows, current),
      );
    };

    timer = setTimeout(
      tick,
      TeamRegistrationService.countdownTickMs(rows, new Date()),
    );

    return () => clearTimeout(timer);
  }, [rows]);

  return now;
}
